import script from "./MediaField.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaField.vue?vue&type=script&lang=ts&setup=true"

import "./MediaField.vue?vue&type=style&index=0&id=6a4205b8&lang=scss"

const __exports__ = script;

export default __exports__